module.exports = __webpack_public_path__ + "static/ux-design-1e799ba3103421accb201b16c962a3d2.jpg";